// removed by extract-text-webpack-plugin
module.exports = {"nf-solicitation-detail":"nf-solicitation-detail","nf-solicitation-detail__header":"nf-solicitation-detail__header","nf-solicitation-detail__subheader":"nf-solicitation-detail__subheader","nf-solicitation-detail__card":"nf-solicitation-detail__card","nf-solicitation-detail__card-header":"nf-solicitation-detail__card-header","nf-solicitation-detail__card-body":"nf-solicitation-detail__card-body"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SendRfq/SendRfq.scss
// module id = 4964
// module chunks = 1